import React, {useEffect, useRef,useState } from "react"; 
import  {gameThumbnailUpdate} from "../../../Services/gameServices"
import { handleFileValidation } from "../../../utils/Api";
import { getEnvUrl } from "../../../utils/Api"; 
import { toast } from 'react-toastify';
import { checkPermissions } from "../../../Services/User/User";
const GameBannersUpdate = ({game_id}) => { 
    let randomNumber    = Math.random();
    const fileInputRef  = useRef(null);
    const hFileInputRef  = useRef(null);
    const vFileInputRef  = useRef(null);
    const [bannerImage,setBannerImage]=useState(`${getEnvUrl()}/game/img?&rand=${randomNumber}&type=b&id=${btoa(btoa(game_id))}&width=300`)
    const [vThumbnailimage,setVThumbnailImage]=useState(`${getEnvUrl()}/game/img?&rand=${randomNumber}&type=v&id=${btoa(btoa(game_id))}&width=100`)
    const [hThumbnailimage,setHThumbnailImage]=useState(`${getEnvUrl()}/game/img?&rand=${randomNumber}&type=h&id=${btoa(btoa(game_id))}&width=300`)
    const [banner,setBanner] = useState(null)
    const [imageRender,setImageRender] = useState(false)
    const [vThumbnail,setvThumbnail] = useState(null) 
    const [hThumbnail,sethThumbnail] = useState(null)
    useEffect(()=>{
        let randomNumber    = Math.random();
        setTimeout(()=>{
            setBannerImage(`${getEnvUrl()}/game/img?&rand=${randomNumber}&type=b&id=${btoa(btoa(game_id))}&width=300`)
            setVThumbnailImage(`${getEnvUrl()}/game/img?&rand=${randomNumber}&type=v&id=${btoa(btoa(game_id))}&width=100`)
            setHThumbnailImage(`${getEnvUrl()}/game/img?&rand=${randomNumber}&type=h&id=${btoa(btoa(game_id))}&width=300`)
         },1000)
       },[imageRender])
    const handleBannerChange = (e) => handleFileValidation(e, setBanner);
    const handleHThumbnailChange = (e) => handleFileValidation(e, sethThumbnail);
    const handleVThumbnailChange = (e) => handleFileValidation(e, setvThumbnail);

    const updateBanner = (type) => { 
        if (!game_id) return; // Ensure game_id exists before proceeding
    
        const formData = new FormData();
        let image = null;
    
        if (type === 'b') image = banner;
        else if (type === 'h') image = hThumbnail;
        else if (type === 'v') image = vThumbnail;
    
        if (!image) return; // Exit if no image is selected
    
        formData.append('picture', image);
        formData.append('type', type);
        formData.append('game_id', game_id);
    
        gameThumbnailUpdate(formData)
            .then((data) => {
                if (data?.status) {
                    toast.success(data.message);
    
                    if (type === 'b') {
                        setImageRender(!imageRender); 
                        if (fileInputRef?.current) fileInputRef.current.value = ""; 
                    }
                    if (type === 'h') {
                        setImageRender(!imageRender); 
                        if (hFileInputRef?.current) hFileInputRef.current.value = "";
                    }
                    if (type === 'v') {
                        setImageRender(!imageRender); 
                        if (vFileInputRef?.current) vFileInputRef.current.value = "";
                    }
                } else {
                    console.log(data)
                    toast.error(data || "Failed to update banner.");
                }
            })
            .catch((error) => {
                console.error("Error updating banner:", error);
                toast.error("Something went wrong. Please try again.");
            });
    };
    
    
  return (
    <div className="card">
        <div className="card-body" style={{ padding: '20px' }}>
            <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Game banner</label>
                <div className="col-lg-9 col-md-8 gvds">
                    <img src={bannerImage} />
                </div>
            </div>
            <div className="row mb-3">
                <label htmlFor="inputNumber" className="col-sm-3 col-form-label"></label>
                <div className="col-sm-6">  
                    <input ref={fileInputRef} className="form-control" type="file" onChange={handleBannerChange}  />
                </div>
                  {checkPermissions('game_banner_update') && <button onClick={() => { updateBanner('b') }} disabled={!banner} className="btn btn-outline-primary col-sm-2">Upload</button>}
             
            </div> 
            <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Game Vertical Thumbnail</label>
                <div className="col-lg-9 col-md-8 gvds">
                    <img src={vThumbnailimage} alt="" />
                </div>
            </div>
            <div className="row mb-3">
                <label htmlFor="inputNumber" className="col-sm-3 col-form-label"></label>
                <div className="col-sm-6"> 
                    <input ref={vFileInputRef} onChange={handleVThumbnailChange} className="form-control" type="file"  />
                </div>
                  {checkPermissions('game_banner_update') && <button onClick={() => { updateBanner('v') }} disabled={!vThumbnail} className="btn btn-outline-primary col-sm-2">Upload</button>}
            </div>
            
            <div className="row mb-3">
                <label className="col-sm-3 col-form-label">Game Horizontal Thumbnail</label>
                <div className="col-lg-9 col-md-8 ghds">
                    <img id="ght" src={hThumbnailimage}  alt="" />
                </div>
            </div>
            <div className="row mb-3">
                <label htmlFor="inputNumber" className="col-sm-3 col-form-label"></label>
                <div className="col-sm-6"> 
                    <input ref={hFileInputRef}  className="form-control" type="file"  onChange={handleHThumbnailChange} />
                </div>
                  {checkPermissions('game_banner_update') && <button onClick={() => { updateBanner('h') }} disabled={!hThumbnail} className="btn btn-outline-primary col-sm-2">Upload</button>}
                
            </div>
        </div>
    </div>
  );
};

export default GameBannersUpdate;

